import { FC } from "react";
import ProjectRunConfiguration from "../projects/projectRunConfiguration";
import moment from "moment";

export interface JobRunConfigProps {
  runConfig: ProjectRunConfiguration;
}

export const JobRunConfigTab: FC<React.PropsWithChildren<JobRunConfigProps>> = (props: JobRunConfigProps) => {
  return (
    <dl className="d-table">
      <div className="d-table-row">
        <dt className="d-table-cell label-s">Type: </dt>
        <dd className="d-table-cell ps-2">{props.runConfig.projectRunConfigurationType.toString().charAt(0).toUpperCase() + props.runConfig.projectRunConfigurationType.toString().slice(1)}</dd>
      </div>
      <div className="d-table-row">
        <dt className="d-table-cell label-s">Status: </dt>
        <dd className="d-table-cell ps-2">{props.runConfig.status.toString().charAt(0).toUpperCase() + props.runConfig.status.toString().slice(1)}</dd>
      </div>
      <div className="d-table-row">
        <dt className="d-table-cell label-s">Date Created: </dt>
        <dd className="d-table-cell ps-2">{moment.utc(props.runConfig.dateCreated).local().format("L LT")}</dd>
      </div>
    </dl>);
};
